<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialogv" fullscreen hide-overlay transition="dialog-bottom-transition">      
      <v-card>        
        <v-card-text class="pa-0">
          <dialog-eks :kompetisi_id="kompetisi_id" :tps_id="tps_id" :kpuurl="kpuurl" :kputpsid="kputpsid" v-on:close="closeDialog($event)" v-if="mode === 1"></dialog-eks>          
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import DialogEks from './dialog-view-eks';

export default {
  name : 'form-dialog',  
  components: {
    DialogEks,   
  },
  props:{    
    cekup  : Object,
    dialog : {
      type: Boolean,
      default: false,
    },
  }, 
  data () {
    return {
      dialogv: false,
      mode : null,
      kompetisi_id:null,
      tps_id:null,
      kputpsid : null,
      kpuurl : null,
      //chat: null,
      //selectedTab: null,
    };
  }, 
  asyncComputed:{
    init(){
      if(!this.dialogv){
        this.dialogv = this.dialog;              
        if(this.dialogv){                    
          this.mode = this.cekup.mode;          
          this.kompetisi_id = String(this.cekup.kompetisi_id);
          this.tps_id = String(this.cekup.tps_id);
          this.kputpsid = String(this.cekup.kputpsid);
          this.kpuurl   = String(this.cekup.kpuurl);
        }        
      } else {
        this.dialogv = this.dialog;
      }
      return;
    }
  },
  /*computed: {
    showFormEks() {
      return this.mode == 1;
    },
    showFormLeg() {
      return this.mode == 2;
    },
    showFormDpd() {
      return this.mode == 3;
    },            
  },*/
  methods: {          
    closeDialog(e){      
      this.dialogv = false;
      this.$emit('closeDialog',{dialog : false, cekup:{}, reload:e});
    }
  } 
};
</script>

